import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { skipToken } from '@reduxjs/toolkit/dist/query/react'
import {
  mrfEnvironmentApi,
  engagementEnvironmentApi,
  employeeEnvironmentApi,
  alertEnvironmentApi,
} from 'services/environment'
import { selectClientId, selectClientModules } from 'services/slices/auth'

const { useGetEnvironmentQuery: useGetEnvironmentEngagementQuery } = engagementEnvironmentApi
const { useGetEnvironmentQuery: useGetEnvironmentMrfQuery } = mrfEnvironmentApi
const { useGetEnvironmentQuery: useGetEmployeeEnvironmentQuery } = employeeEnvironmentApi
const { useGetEnvironmentQuery: useGetAlertEnvironmentQuery } = alertEnvironmentApi

//paths that need env, checks with startsWith, so get the path from the beginning
const mrfEnvPaths = ['/mrf_management', '/ops_management/tasks/']
const engEnvPaths = ['/engagement', '/ops_management/tasks/']
const employeeEnvPaths = ['/employee']
const alertEnvPaths = ['/alert']

const shouldEnvLoad = (
  module: 'eng' | 'mrf' | 'employee' | 'alert',
  pathName: string,
  isModuleUse: boolean,
  clientId?: number,
) => {
  let result = false
  const currentPathArr = (() => {
    switch (module) {
      case 'mrf':
        return mrfEnvPaths
      case 'eng':
        return engEnvPaths
      case 'employee':
        return employeeEnvPaths
      case 'alert':
        return alertEnvPaths
      default:
        return []
    }
  })()

  currentPathArr.forEach((path) => {
    if (pathName.startsWith(path) && isModuleUse && Number(clientId) !== 0) {
      result = true
    }
  })
  return result
}

export const EnvironmentProvider: React.FC<{}> = () => {
  const { pathname } = useLocation()
  const clientId = useSelector(selectClientId)
  const { mrf, engagement, employee, alert } = useSelector(selectClientModules)
  useGetEnvironmentEngagementQuery(
    shouldEnvLoad('eng', pathname, engagement, clientId) ? clientId : skipToken,
  )
  useGetEnvironmentMrfQuery(shouldEnvLoad('mrf', pathname, mrf, clientId) ? clientId : skipToken)
  useGetEmployeeEnvironmentQuery(
    shouldEnvLoad('employee', pathname, employee, clientId) && clientId ? clientId : skipToken,
  )
  useGetAlertEnvironmentQuery(
    shouldEnvLoad('alert', pathname, alert, clientId) && clientId ? clientId : skipToken,
  )

  return null
}
